import { Component } from '@angular/core';
import { environment } from 'apps/webapp/src/environments/environment';
import { NotificationService } from '../../../../shared/notification/notification.service';
import { SpinnerService } from '../../../../spinner/spinner.service';
import { StaticInfoService } from '@backend/webapp/services/static-info.service';

@Component({
    selector: 'backend-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.css'],
    standalone: false
})
export class LoginModalComponent {
  public constructor(
    private readonly notificationService: NotificationService,
    private readonly spinnerService: SpinnerService,
    private readonly staticInfo: StaticInfoService
    ){}
  public open = false;
  windows_QR_Code = environment.windows_QR_Code;
  public latestBuildText: string = 'Loading...';

  closeModal(){
    this.open = false;
  }

  downloadLatestBuild() {
  this.spinnerService.showSpinner();
  try {
    const jsonData = this.staticInfo.getStaticInfo();
    if (!jsonData) {
      this.notificationService.error('Error', 'No build data available.');
      return;
    }
    const builds = jsonData?.sections?.[0]?.builds || [];
    const latestBuild = builds.find(
      (build) => build.buildFile && build.buildFile.trim() !== ''
    );
    if (latestBuild) {
      const downloadUrl = '/' + latestBuild.buildFile;
      window.open(downloadUrl, '_blank');
    } else {
      this.notificationService.error(
        'Download Error',
        'No downloadable build file was found.',
        null,
        null
      );
    }
  } catch (error) {
    console.error('Download failed:', error);
    this.notificationService.error(
      'Unexpected Error',
      'Something went wrong while downloading.',
      null,
      null
    );
  } finally {
    this.spinnerService.hideSpinner();
  }
  }
}
